export const LOTTE_CATEGORY_FIELD = {
    // store
    LARGE_CLASSIFICATION_NAME: 'lrclsNm',
    // f&b
    MEDIUM_CLASSIFICATION_NAME: 'mdclsNm',
    // facility
    SMALL_CLASSIFICATION_NAME: 'smclsNm',

    // poi
    // store
    LARGE_CLASSIFICATION_CODE: 'lrclsCd',

    // f&b
    MEDIUM_CLASSIFICATION_CODE: 'mdclsCd',

    // facility  + L001
    SMALL_CLASSIFICATION_CODE: 'smclsCd',

    OTHER_FACILITY_CODE: 'L001',

    // duty-free facility children (elevator / restroom / escalator)
    DUTY_FREE_OTHER_FACILITY_CODE: 'LDFS002',
};

/** Escalator, elevator, restroom — only merged into other-facility when the POI is duty-free. */
export const DUTY_FREE_OTHER_FACILITY_CLIENT_CODES = new Set(['S003', 'S001', 'S002']);
